export const labelsForm = {

  select: 'Day:',
  inicialInput: 'Customer service starts at:',
  finalInput: 'Customer service stops at:',
  button: 'Add'

}

export const labelPanelButton = {
  generateCode: 'Generate Script',
  generateTemplate: 'Generate Template',
  download: 'Download',
  return: 'Go Back'
}